module.exports = __webpack_public_path__ + "media/images/icon-pro-9f98e9412ce31501c5b5545d13d01039.svg";